export default __webpack_public_path__ + "static/media/Ente-auf-Wiese.59e671dd.webp";